module.exports = __webpack_public_path__ + "static/template-preview-e6088d46fe5bda8d46aae91cb78d1cec.png";